// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-3{margin-top:30px}.blacklist-detail-main{position:relative}.blacklist-detail-main .blacklist-detail-main-ab{top:10px;right:5px;position:absolute;z-index:10}.blacklist-detail-main .blacklist-detail-edit{top:10px;right:40px;position:absolute;z-index:10}input[value^=\"example.com\"],input[value^=\"iexplore.exe\"]{border-color:#047fff}\n", ""]);
// Exports
module.exports = exports;
